import { render, staticRenderFns } from "./sendIp.vue?vue&type=template&id=b36d2328&scoped=true&"
import script from "./sendIp.vue?vue&type=script&lang=js&"
export * from "./sendIp.vue?vue&type=script&lang=js&"
import style0 from "./sendIp.vue?vue&type=style&index=0&id=b36d2328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36d2328",
  null
  
)

export default component.exports